import React from 'react';
import { doHref } from '../utils/doHref';

export const Category = ({ term_id, name, count_with_sub, slug, image }) => {
  return (
    <a className="category" href={doHref({ category: slug })}>
      <div>
        <img alt={name} src={image} />
      </div>
      <div className="category-name">
        {name} ({count_with_sub})
      </div>
    </a>
  );
};
